import React, { useContext, useState } from "react";
import { NotifyContext } from "../../context/notifyContext";
import { Newsletter } from "../../Types/newsletter";
import NewsletterAPI from "../../services/api/newsletterService";
import Button from "../../UI/Button/Button";
import ButtonLoading from "../../UI/Button/ButtonLoading";

interface SendNewsletterProps {
  onClose: () => void;
  newsletter?: Newsletter | null;
}

export default function SendNewsletter({
  onClose,
  newsletter,
}: SendNewsletterProps) {
  const notify = useContext(NotifyContext);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!newsletter) return;
    setLoading(true);

    try {
      await NewsletterAPI.send_newsletter(newsletter.id);
      notify("Newsletter envoyée avec succès", "success");
      onClose();
    } catch (error) {
      notify(error, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <p>Êtes-vous sûr de vouloir envoyer cette newsletter ?</p>
      <div className="flex justify-end gap-2">
        <Button color="error" onClick={onClose}>
          Annuler
        </Button>
        <ButtonLoading
          type="submit"
          loading={loading}
          label="Envoyer"
          onClick={handleSend}
        />
      </div>
    </div>
  );
} 